import * as Sentry from "@sentry/react";

const isSocketIoTransaction = ctx => {
  const name = ctx?.name || ctx?.transactionContext?.name || "";
  const op = ctx?.op || ctx?.transactionContext?.op || "";
  if (name.includes("/socket.io/")) return true;
  if (op.startsWith("websocket")) return true;
  return false;
};

if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    autoSessionTracking: true,
    environment: import.meta.env.VITE_DOMAIN || "development",
    release: import.meta.env.VITE_SENTRY_RELEASE,
    tracesSampler: samplingContext => {
      // Engine.IO long-polling handshakes look like slow XHRs to Sentry's
      // BrowserTracing autoinstrumentation; drop them so they don't fire
      // false "degraded API performance" alerts.
      if (isSocketIoTransaction(samplingContext)) return 0;
      return 0.01;
    },
    beforeSend(event, hint) {
      const error = hint.originalException;
      if (error?.response?.status === 401) {
        const url = error?.config?.url || "";
        const isTokenRotation =
          url.includes("/auth/refresh") || url.includes("/auth/login");
        if (isTokenRotation) return null;
      }
      return event;
    },
  });
  Sentry.setTag("domain", import.meta.env.VITE_DOMAIN || "unknown");
}
